module.exports = __webpack_public_path__ + "media/images/cc-icons-5e75d7b2.svg";